import { useEffect, useMemo } from 'react'

import {
  extractRelatedRepliesRefs,
  replaceKeyWithDefaultValue,
  replaceKeyWithValue,
  sanitizeBeforeCalc,
  setValueWhenCalcIsReady,
  setValueWhenDefaultValueIsReady
} from '../_helper/calc'

const QUESTIONS_CAN_HAVE_CALC = ['calc', 'float', 'numeric', 'place', 'asset', 'user', 'text']

const useCalcReplies = (localReply, components, allReplies, questions) => {
  const { questionType } = questions
  const calcsReplies = allReplies?.filter(reply => QUESTIONS_CAN_HAVE_CALC.includes(reply?.question?.type?.name)) || []

  const repliesIndex = useMemo(() => {
    return allReplies.reduce((acc, reply) => {
      if (reply?.question?.reference) {
        acc[reply?.question?.reference] = reply
      }
      return acc
    }, {})
  }, [allReplies])

  useEffect(() => {
    if (QUESTIONS_CAN_HAVE_CALC.includes(questionType)) {
      calcsReplies.forEach(element => {
        const questionData = element?.question?.data?.calc || element?.question?.data?.defaultValue
        const references = extractRelatedRepliesRefs(questionData)
        const relatedReplies = references.map(reference => repliesIndex[reference]).filter(Boolean)

        let calc = element?.question?.data?.calc || element?.question?.data?.defaultValue
        calc = sanitizeBeforeCalc(calc)

        if (element.question.type.name === 'calc' && calc) {
          setValueWhenCalcIsReady(components, element, calc)
        }

        if (element.question.type.name === 'text' && calc) {
          setValueWhenDefaultValueIsReady(components, element, calc)
        }

        relatedReplies.forEach((reply, index) => {
          const replyValue = components?.current[reply?.questionId]?.getValue()
          const value = reply?.type === 'user' ? replyValue?.contract : replyValue

          if (element.question.type.name === 'calc' && calc) {
            calc = replaceKeyWithValue(calc, references[index], value)
            setValueWhenCalcIsReady(components, element, calc)
          }

          if (element.question.type.name === 'text' && calc) {
            calc = replaceKeyWithDefaultValue(calc, references[index], value)
            setValueWhenDefaultValueIsReady(components, element, calc)
          }
        })
      })
    }
  }, [localReply?.value, allReplies])

  return
}

export default useCalcReplies
